import * as types from './types';

const fetchMessagesSeeker = id => ({ type: types.FETCH_SEEKER_MESSAGES, payload: id });
const fetchMessagesSeekerSucceeded = data => ({ type: types.FETCH_SEEKER_MESSAGES_SUCCEEDED, payload: data });
const fetchMessagesSeekerFailed = error => ({ type: types.FETCH_SEEKER_MESSAGES_FAILED, payload: error });
const fetchMessagesSeekerReset = data => ({ type: types.FETCH_SEEKER_MESSAGES_RESET, payload: data });
const addMessageSeeker = message => ({ type: types.ADD_SEEKER_MESSAGE, payload: message });
const addMessageSeekerSucceded = message => ({ type: types.ADD_SEEKER_MESSAGE_SUCCEEDED, payload: message });

const addFile = id => ({ type: types.ADD_FILE, payload: id });
const addFileSuceeded = data => ({ type: types.ADD_FILE_SUCCEEDED, payload: data });
const removeFile = id => ({ type: types.REMOVE_FILE, payload: id });
const resetFileState = data => ({ type: types.RESET_FILES, payload: {} });
const errorUpload = data => ({ type: types.ERROR_UPLOAD, payload: {} });
const showSnackBar = snackBarOptions => ({ type: types.SHOW_SNACKBAR, payload: snackBarOptions });
const hideSnackBar = () => ({ type: types.HIDE_SNACKBAR });
const revertError = () => ({ type: types.REVERT_ERROR });
const showModal = () => ({ type: types.SHOW_MODAL });

export {
  addMessageSeeker,
  fetchMessagesSeeker,
  fetchMessagesSeekerSucceeded,
  fetchMessagesSeekerFailed,
  addMessageSeekerSucceded,
  fetchMessagesSeekerReset,
  addFileSuceeded,
  removeFile,
  resetFileState,
  errorUpload,
  showSnackBar,
  hideSnackBar,
  revertError,
  addFile,
  showModal
};
